import React, { Component } from "react";
import swal from "sweetalert";
import { withTranslation} from "react-i18next";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {withTheme,} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Loader from "../loaders/loader";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Questionnaire from "./CassePreviewQuestionnaire";
import ApiServices from "../../api/api";
import OffileDb from '../../config/pouchDB';
import { logError } from "../../helpers/auth";
class SurveyCasePreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      serviceDetails: [],
      lat: "",
      lng: "",
      imageURLs: [],
      audioURLs: [],
      videoURLs: []
    };
  }

  componentDidMount() {
    var self = this;
    /**START GET LATITUBE & LONGITUDE */
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    navigator.geolocation.getCurrentPosition(
      function (position) {
        self.setState({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          zoom: 13
        });
      },
      null,
      options
    );

    /**END GET LATITUBE & LONGITUDE */
    if (!this.props.location.state) {
      this.props.history.goBack();
    } else {
      this.loadCaseForm(this.props.location.state);
    }
  }

  loadCaseForm(obj) {
    if(obj.casetype != "offline") {
      this.loadOfflineData(obj)
    } else {
      this.loadOfflieCasePreview(obj)
    }
  }

  loadOfflieCasePreview(obj){
    this.setState({
      serviceDetails: obj,
      isLoading: false,
    });
  }

  loadCaseApiForm(obj){
    if (navigator.onLine) {
      var localid = "servicesCaseDetails" + obj.caseId
      var param = {
        "caseId": obj.caseId,
        "languageId": obj.languageId,
        "selectedLanguage": parseInt(this.props.langId)
      }
      this.setState({ isLoading: true });
      ApiServices.getCaseDetailsForService(param).then((res) => {
        try{
          if (res.status == 200) {
            this.setState({
              serviceDetails: res.data.data,
              isLoading: false,
            });
            OffileDb.setData(localid, res.data.data)
          }
        }catch(err){
          console.log("err::", err)
          var errorObj = {
            component: 'ServicesCasePreview',
            method: 'loadCaseApiForm',
            error: err
          }
          logError(errorObj);
        }
      });
    }
  }

  loadOfflineData(obj) {
    var that = this
    var id = "servicesCaseDetails" + obj.caseId
    OffileDb.getData(id).then(function (result) {
      console.log(result)
      if (result.status && result.status == 404) {
        if (!navigator.onLine) {
          swal({
            text: "Offline data is not available",
            icon: "success",
            button: "Ok",
          }).then((val) => {
            that.props.history.push("/layout/services");
          });
        } else{
          that.loadCaseApiForm(obj)
        }
      } else {
        that.setState({
          serviceDetails: result.data,
          isLoading: false
        });
      }
    });
  }


  render() {
    const { location } = { ...this.props };
    const { t } = this.props;
    const { templateID } = this.props;

    if (!location.state) {
    }

    return (
      <div className="gk-page getknowledgeable_page">
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
        <div className="gridcontainer">
          <form id="surveyCasePreviewform">
          <div className={templateID == 2 ? "forumlistdivholder" : "forumlistdivholder getinvo_inner_questiondiv"}>
              {this.state.isLoading ? (
                <Loader isLoading={this.state.isLoading} />
              ) : this.state && this.state.serviceDetails && this.state.serviceDetails.length == 0 ? (
                <p>{t('No Data Found')}</p>
              ) : (
                this.state.serviceDetails.questionResponse.map((Obj) => {
                  return <Questionnaire question={Obj} />;
                })
              )}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

// export default withRouter(ServiceForm);

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
  };
};

const tSurveyCasePreview = withTranslation()(SurveyCasePreview);
const ThemeSurveyForm = withTheme(tSurveyCasePreview);
const routeSurveyForm = withRouter(ThemeSurveyForm);
export default connect(mapStateToProps, {})(routeSurveyForm);
